import { useEffect } from "react";
import { Typography } from "@mui/material";
import pluralize from "pluralize";

import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import selectedCastNumber from "utils/selectedCastNumber";

const SingleCast = ({ templateGroup }) => {
  const count = TemplateGroupPresenter.castsCount(templateGroup);
  const firstCastNum = TemplateGroupPresenter.firstCastNum(templateGroup);
  const msgEnd = pluralize("Person", TemplateGroupPresenter.castsCount(templateGroup));

  useEffect(() => {
    selectedCastNumber.set(firstCastNum);
  }, []);

  return (
    <Typography component="p" align="center">
      {`Cast ${count} ${msgEnd}`}
    </Typography>
  );
};

SingleCast.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
};

export default SingleCast;
